import selectEnhancements from 'html/customize/select-enhancements.html';
import App from 'app/app.js';
import 'app/directive/LtSelectEnhancementsCtrl.js';

function LtSelectEnhancementsDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      updateStdPriceRetouchingOptIn: '&',
      updatePersonalizationName: '&',
      updateStdPricePersonalizationOptIn: '&',
      saveToCart: '&',
      goToPreviousPage: '&',
      isBasicRetouching: '=',
      hasOptOut: '=',
      partialEnhancements: '=',
      noNoGo: '=',
      packageHasNoYo: '=',
      noRetouching: '=',
      standardizedPricingOptIns: '=',
      personalizationName: '=',
      personalizationIsValid: '=',
      isStandardizedPricingPackage: '=',
      availableEnhancements: '=',
      sku: '=',
      upgradeOptions: '=',
      backToPreviousPageLabel: '='
    },
    template: selectEnhancements,
    controller: 'LtSelectEnhancementsCtrl',
    controllerAs: 'selectEnhancements'
  };
}

App.directive('ltSelectEnhancementsDrawer', [LtSelectEnhancementsDirective]);
